import PREVIOUS_SEARCH_COUNT from 'constants/previous-search-count';

export default function OnewayBaseController(
    $scope,
    $state,
    flightsFactory,
    moment,
    flightsUtils,
    flightsService,
    userService,
    timeService,
    l10nService,
    cfg,
) {
    'ngInject';

            let allSearchesFetched = false;
            $scope.showOptions = flightsFactory.showOptions;

            $scope.flightType = 'oneway';

            $scope.l10nService = l10nService;

            $scope.moment = moment;

            $scope.updateArrival = function(isArrival) {
                $scope.params.TicketSearchSegments[0]._isArrivalTime = isArrival;
            };
            $scope.updateArrivalOneWay = function(index, value) {
                $scope.params.TicketSearchSegments[index]._isArrivalTime = value;
            };
            $scope.$watch('params.TicketSearchSegments[0]._date', () => {
                departTimeWatcher();
                flightsUtils.refreshReturnedDate.bind($scope.params.TicketSearchSegments);
            });

            $scope.isCurrentDay = flightsService.isCurrentDay;
            $scope.workingHoursRestriction = userService.getUser().WorkingHoursRestriction;

            function departTimeWatcher() {
                flightsUtils.departureTimeWatcher(
                    $scope.params.TicketSearchSegments[0]._date,
                    $scope.options.time0,
                    $scope.params.TicketSearchSegments[0]._time,
                    $scope.options.time
                );
            }

            /* Time Picker */
            const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate($scope.params.TicketSearchSegments[0]._date);

            function fetchTop() {
                const ONE_WAT_FLIGHT = 0;
                flightsFactory.getTopPreviousSearches(ONE_WAT_FLIGHT)
                    .then(setPreviousSearches);
            }

            function fetchAll() {
                if (allSearchesFetched) {
                    return;
                }

                flightsFactory.getAllPreviousSearches(0)
                    .then(setPreviousSearches)
                    .then(() => allSearchesFetched = true);
            }

            function setPreviousSearches({data}) {
                $scope.previousSearches = data;
            }

            $scope.optionsDepart = {
                placeholder: l10nService.localize('Date'),
                required: true,
                months: 2,
                before: flightsFactory.getMaxBookDate(),
                start: initialDepartDate,
                after: moment().add({days: -1}),
            };

            $scope.previousSearches = [];
            $scope.maxPreviousSearches = PREVIOUS_SEARCH_COUNT.TOP;

            $scope.allPreviousResultsShown = function() {
                return $scope.maxPreviousSearches === PREVIOUS_SEARCH_COUNT.EXTENDED;
            };

            $scope.togglePreviousSearches = function() {
                fetchAll();
                $scope.maxPreviousSearches = $scope.allPreviousResultsShown()
                    ? PREVIOUS_SEARCH_COUNT.TOP
                    : PREVIOUS_SEARCH_COUNT.EXTENDED;
            };

            $scope.findFlights = function() {
                $scope.params.flightType = 'oneway';
                $scope.params.resetPagination();
                flightsFactory.fetchFlights(angular.copy($scope.params), false,
                    {outbound: $scope.params.TicketSearchSegments[0]._isArrivalTime})
                    .then(() => {
                        $state.go(cfg.resultsRoute);
                    });

            };

            $scope.repeatSearch = function(search, type, options) {
                // set open state of 'more options' panel
                $scope.showOptions = flightsUtils.moreOptionsApplied(search);
                flightsFactory.getSearch(search.Id)
                    .then(function(res) {
                        angular.forEach(res.data.TicketSearchSegments, function(segment, i) {
                            segment.IsDepartureCity = search.SearchSegments[i].IsDeparturePointCity;
                            segment.IsArrivalCity = search.SearchSegments[i].IsArrivalPointCity;
                        });

                        $scope.updateArrival(res.data.TicketSearchSegments[0].DayTimeFilterSource);

                        flightsFactory.params.recreate(search, res.data, options, type);
                        return flightsFactory.fetchFlights(res.data, true);
                    })
                    .then(function() {
                        $state.go(cfg.resultsRoute);
                    });
            };
    fetchTop();
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/onewayBaseCtrl.js